/* __next_internal_client_entry_do_not_use__ MobileLanguageSelector auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getFullLanguageName } from "@faire/web--source/common/consts/THREE_TO_FULL_LANGUAGE_NAME";
import { getTwoLetterLanguageCode } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";
import { hasDuplicateLanguages, isLanguageDuplicatedInLocales } from "@faire/web--source/common/localization/languageOptions";
import { localeKeyToFullLanguageName } from "@faire/web--source/common/localization/localeKeyToFullLanguageName";
import { localeKeyToLocaleString } from "@faire/web--source/common/localization/localeKeyToLocaleString";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Global } from "@faire/web--source/slate/icons/foundation/Global";
import { Typography } from "@faire/web--source/slate/Typography";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { observer } from "mobx-react";
import * as React from "react";
import { useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { LanguageDropdown } from "./LanguageDropdown";
var MobileLanguageSelectorBase = function(props) {
    var _useState = _sliced_to_array(useState(false), 2), isShowingLanguageSelector = _useState[0], setIsShowingLanguageSelector = _useState[1];
    var toggleLanguageSelector = useCallback(function() {
        setIsShowingLanguageSelector(function(isShowingLanguageSelector) {
            return !isShowingLanguageSelector;
        });
    }, []);
    var availableLocalesHasDuplicateLanguages = useMemo(function() {
        return hasDuplicateLanguages(props.availableLocales);
    }, [
        props.availableLocales
    ]);
    var selectedText = useMemo(function() {
        if (!availableLocalesHasDuplicateLanguages || props.browserLocale === undefined) {
            return props.displayFullLanguageName ? getFullLanguageName(props.browserLanguage) : getTwoLetterLanguageCode(props.browserLanguage);
        }
        if (props.browserLocale.language === Language.LANGUAGE_UNKNOWN) {
            return "";
        }
        var includeCountry = !!props.browserLocale && props.browserLocale.language && isLanguageDuplicatedInLocales(Language[props.browserLocale.language], props.availableLocales);
        return props.displayFullLanguageName ? localeKeyToFullLanguageName(props.browserLocale, includeCountry) : localeKeyToLocaleString({
            localeKey: props.browserLocale,
            includeCountry: includeCountry,
            lowercaseLanguage: false
        });
    }, [
        availableLocalesHasDuplicateLanguages,
        props.availableLocales,
        props.browserLanguage,
        props.browserLocale,
        props.displayFullLanguageName
    ]);
    return /*#__PURE__*/ _jsxs(LanguageSelectorDropdownWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(Toggle, {
                onClick: toggleLanguageSelector,
                $hideGlobalIcon: props.hideGlobalIcon,
                children: [
                    props.hideGlobalIcon ? null : /*#__PURE__*/ _jsx(Global, {}),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: selectedText
                    }),
                    /*#__PURE__*/ _jsx(Chevron, {
                        className: "chevron",
                        direction: isShowingLanguageSelector ? "up" : "down"
                    })
                ]
            }),
            isShowingLanguageSelector ? /*#__PURE__*/ _jsx(LanguageDropdown, _object_spread_props(_object_spread({}, props), {
                eventName: "mobile-view-language-selector"
            })) : null
        ]
    });
};
export var MobileLanguageSelector = observer(MobileLanguageSelectorBase);
var LanguageSelectorDropdownWrapper = styled.div.withConfig({
    componentId: "sc-1fbd7e83-0"
})([
    "position:relative;"
]);
/**
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/Toggle/Toggle#Toggle"
 */ var Toggle = styled.button.withConfig({
    componentId: "sc-1fbd7e83-1"
})([
    "display:flex;flex-direction:row;align-items:center;position:relative;width:100%;cursor:pointer;height:36px;justify-content:space-between;margin-top:8px;margin-bottom:8px;min-width:100px;& svg{font-size:12px;}& .chevron{margin-left:12px;}& p{",
    " margin-right:auto;}"
], function(param) {
    var $hideGlobalIcon = param.$hideGlobalIcon;
    return $hideGlobalIcon ? undefined : "margin-left: 12px;";
});
